import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function save(_x) {
  return _save.apply(this, arguments);
}

function _save() {
  _save = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        _response,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/payments',
              data: queryParams,
              method: 'POST'
            });

          case 4:
            _response = _context.sent;
            return _context.abrupt("return", _response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _save.apply(this, arguments);
}

export function paypal(_x2) {
  return _paypal.apply(this, arguments);
}

function _paypal() {
  _paypal = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        _response2,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: '/paypal',
              data: queryParams,
              method: 'POST'
            });

          case 4:
            _response2 = _context2.sent;
            return _context2.abrupt("return", _response2);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", _context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _paypal.apply(this, arguments);
}

export function paypalConfirmation(_x3) {
  return _paypalConfirmation.apply(this, arguments);
}

function _paypalConfirmation() {
  _paypalConfirmation = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(ctx) {
    var queryParams,
        _response3,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.prev = 1;
            _context3.next = 4;
            return axiosInstance({
              url: '/paypal/apply',
              data: queryParams,
              method: 'POST'
            });

          case 4:
            _response3 = _context3.sent;
            return _context3.abrupt("return", _response3);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", _context3.t0);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return _paypalConfirmation.apply(this, arguments);
}

export function apply(_x4) {
  return _apply.apply(this, arguments);
}

function _apply() {
  _apply = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(ctx) {
    var queryParams,
        _response4,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            queryParams = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _context4.prev = 1;
            _context4.next = 4;
            return axiosInstance({
              url: "payments/apply/".concat(queryParams.id),
              method: 'PUT'
            });

          case 4:
            _response4 = _context4.sent;
            return _context4.abrupt("return", _response4);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", _context4.t0);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 8]]);
  }));
  return _apply.apply(this, arguments);
}

export function orderCompleted(_x5) {
  return _orderCompleted.apply(this, arguments);
}

function _orderCompleted() {
  _orderCompleted = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(ctx) {
    var queryParams,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            _context5.prev = 1;
            ctx.commit('orderCompleted', queryParams);
            return _context5.abrupt("return", response);

          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", _context5.t0);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 6]]);
  }));
  return _orderCompleted.apply(this, arguments);
}

export function resendEmail(_x6) {
  return _resendEmail.apply(this, arguments);
}

function _resendEmail() {
  _resendEmail = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(ctx) {
    var queryParams,
        _response5,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            queryParams = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
            _context6.prev = 1;
            _context6.next = 4;
            return axiosInstance({
              url: '/send-purchase',
              data: queryParams,
              method: 'POST'
            });

          case 4:
            _response5 = _context6.sent;
            return _context6.abrupt("return", _response5);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](1);
            return _context6.abrupt("return", _context6.t0);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 8]]);
  }));
  return _resendEmail.apply(this, arguments);
}